import axios from 'axios';
import { FETCH_BLOCK_INFO, FETCH_BLOCKS, FETCH_BLOCK_CATS, RESET_BLOCKS, SET_EXERCISES_LOAD_MORE  } from '../actionTypes';
import { showLoader, hideLoader } from './loader';

export const fetchBlock = (blockId) => (dispatch) => {
  const filter = {blockId: blockId};
  const promises = [];
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  dispatch(showLoader());
  promises.push(axios.get(`plans`, {params: {...filter, _expand: 'exercise'}}));
  promises.push(axios.get(`circuits`, {params: filter}));
  promises.push(axios.get(`sequences`, {params: {blockId: blockId}}));
  promises.push(axios.get(`blocks/${blockId}`));
  return new Promise((respond,rej) => {
    Promise.all(promises).then((values) => {
      const planData = values[0].data;
      const circuitData = values[1].data;
      const sequenceData = values[2].data;
      const blockData = {
        ...values[3].data,
        info: {
          plans: planData,
          circuits: circuitData,
          sequences: sequenceData
        }
      }
      dispatch({
        type: FETCH_BLOCK_INFO,
        payload: blockData
      });
      dispatch(hideLoader());
      respond();
    });
  });
}

export const fetchList = (query) => (dispatch) => {
  const promises = [];
  dispatch(showLoader());
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  promises.push(axios.get('categories',{params:{type:'block'}}));
  promises.push(axios.get('blocks', {params:query }));
  return new Promise((respond,rej) => {
    Promise.all(promises).then((values) => {
      const blockCats = values[0].data;
      const blocksData = values[1].data;
     dispatch({
        type: FETCH_BLOCKS,
        payload: blocksData
      })
      dispatch({
        type: FETCH_BLOCK_CATS,
        payload: blockCats
      });
      dispatch(hideLoader());
      respond();
    });
  });
}

export const fetchMoreBlock = (query) => dispatch => {
	const promises = [];
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises.push(
		axios.get('blocks', {
			params: query,
		})
	);
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const data = values[0].data;
			dispatch({
				type: FETCH_BLOCKS,
				payload: data,
			});
		});
	});
};

export const resetBlock = () => dispatch => {
	dispatch({
		type: RESET_BLOCKS,
    payload: []
	});
};


// WEBPACK FOOTER //
// ./src/store/actions/blocks.js